/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

export type GetExchangeSubAccountTransferResponseDataItemStatus = typeof GetExchangeSubAccountTransferResponseDataItemStatus[keyof typeof GetExchangeSubAccountTransferResponseDataItemStatus];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetExchangeSubAccountTransferResponseDataItemStatus = {
  DRAFT: 'DRAFT',
  QUOTED: 'QUOTED',
  NEW: 'NEW',
  PROCESSING: 'PROCESSING',
  SUCCESS: 'SUCCESS',
  CANCEL: 'CANCEL',
  APPROVE: 'APPROVE',
  FAIL: 'FAIL',
  ERROR: 'ERROR',
} as const;
